import React, { useState, useEffect } from 'react';
import { getPlatforms, IonAlert, IonButton, IonButtons, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonList, IonListHeader, IonLoading, IonModal, IonPage, IonTextarea, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import './Tab2.css';

import axios from '../utils/axiosInstance';

interface alert {
  isOpen: boolean;
  message: string;
}

interface ReportFormProps {
  setReportModal: (status: boolean) => void;
  setAlert: (arg0: alert) => void;
}

const ReportForm: React.FC<ReportFormProps> = ({setReportModal, setAlert}) => {
  const [showLoading, setShowLoading] = useState(false);

  const [name, setName] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [phone, setPhone] = useState<string>();
  const [requestProjectCode, setRequestProjectCode] = useState<string>();
  const [title, setTitle] = useState<string>();
  const [content, setContent] = useState<string>();

  useEffect(() => {
    setName(localStorage.getItem('legalName')!)
    setEmail(localStorage.getItem('email')!)
    setPhone(localStorage.getItem('cellPhone')!)
    setRequestProjectCode(localStorage.getItem('projectCode')!)
  }, [])

  function submitReport() {
    setShowLoading(true);
    const headers = {
      "X-Access-Token": window.localStorage.getItem("token")
    }
    const tags = getPlatforms()
    const data = {
      subject: 'Maintenance',
      title,
      content,
      name,
      email,
      phone,
      requestProjectCode,
      memberId: window.localStorage.getItem("memberId"),
      tags: JSON.stringify(tags),
      images: JSON.stringify([]),
      projectCode: 'JWY',
      status: 'P'
    }
    console.log(data)
    axios({
      method: 'POST',
      url: '/gateway/private/cs/v1/tickets',
      headers,
      data
    })
      .then(({data})=> {
        if(data.returnCode === '000000') {
          setReportModal(false);
          setShowLoading(false);
          setAlert({
            isOpen: true,
            message: "已收到您到問題回報。",
          });          
        }
      })
  }

  return(
    <IonList>
      <IonItem>
        <IonLabel position="fixed">名稱</IonLabel>
        <IonInput value={name} placeholder="範例：白傑升" onIonChange={e => setName(e.detail.value!)}></IonInput>
      </IonItem>
      <IonItem>
        <IonLabel position="fixed">聯絡電話</IonLabel>
        <IonInput value={phone} placeholder="範例：0912345678" onIonChange={e => setPhone(e.detail.value!)}></IonInput>
      </IonItem>
      <IonItem>
        <IonLabel position="fixed">Email</IonLabel>
        <IonInput value={email} placeholder="範例：test@mail.com" onIonChange={e => setEmail(e.detail.value!)}></IonInput>
      </IonItem>
      <IonItem>
        <IonLabel position="fixed">問題主旨</IonLabel>
        <IonInput value={title} placeholder="請輸入問題主旨" onIonChange={e => setTitle(e.detail.value!)}></IonInput>
      </IonItem>
      <IonItem>
        <IonLabel position="fixed">問題內容</IonLabel>
        <IonTextarea value={content} rows={6} cols={20} placeholder="範例：打卡系統無法取得..." onIonChange={e => setContent(e.detail.value!)}></IonTextarea>
      </IonItem>
      <IonButton color="primary" expand="block" onClick={() => submitReport()}>回報</IonButton>
      <IonLoading
        isOpen={showLoading}
        message={'Please wait...'}
      />
    </IonList>
  )
}

const AccountForm: React.FC = () => {
  const [showLoading, setShowLoading] = useState(false);
  const [Toast, setToast] = useState(false);

  const [legalName, setLegalName] = useState<string>();
  const [nickname, setNickname] = useState<string>();
  const [phone, setPhone] = useState<string>();
  const [cellPhone, setCellPhone] = useState<string>();

  useEffect(() => {
    setShowLoading(true)
    loadData()
    return () => {
    }
  }, [])

  function loadData() {
    const memberId = window.localStorage.getItem('memberId');
    const headers = {
      "X-Access-Token": window.localStorage.getItem("token")
    };    
    axios({
      method: 'GET',
      url: `/gateway/private/core/v1/profiles/${memberId}`,
      headers
    })
      .then(({data})=> {
        if (data.returnCode === '000000') {
          const { legalName, nickname, phone, cellPhone } = data.info;
          setLegalName(legalName);
          setNickname(nickname);
          setPhone(phone);
          setCellPhone(cellPhone);
          setShowLoading(false);
        }
      })
  };
  function patchAccount() {
    setShowLoading(true);
    const memberId = window.localStorage.getItem('memberId');
    const headers = {
      "X-Access-Token": window.localStorage.getItem("token")
    }
    const data = {
      legalName,
      nickname,
      phone,
      cellPhone
    };
    axios({
      method: 'PATCH',
      url: `/gateway/proxy/core/v1/profiles/${memberId}`,
      headers,
      data
    })
      .then(({data})=> {
        if (data.returnCode === '000000') {
          const { legalName, email, cellPhone } = data.info;
          localStorage.setItem("legalName", legalName);
          localStorage.setItem("email", email);
          localStorage.setItem("cellPhone", cellPhone);
          setShowLoading(false);
          setToast(true)
        }
      })
  };

  return (
    <IonList>
      <IonItem>
        <IonLabel position="fixed">真實姓名</IonLabel>
        <IonInput value={legalName} placeholder="範例：白傑升" onIonChange={e => setLegalName(e.detail.value!)}></IonInput>
      </IonItem>
      <IonItem>
        <IonLabel position="fixed">暱稱</IonLabel>
        <IonInput value={nickname} placeholder="範例：Bai" onIonChange={e => setNickname(e.detail.value!)}></IonInput>
      </IonItem>
      <IonItem>
        <IonLabel position="fixed">電話</IonLabel>
        <IonInput value={phone} placeholder="範例：037" onIonChange={e => setPhone(e.detail.value!)}></IonInput>
      </IonItem>
      <IonItem>
        <IonLabel position="fixed">手機</IonLabel>
        <IonInput value={cellPhone} placeholder="範例：0912345678" onIonChange={e => setCellPhone(e.detail.value!)}></IonInput>
      </IonItem>
      <IonButton color="primary" expand="block" onClick={() => patchAccount()}>更新</IonButton>
      <IonLoading
        isOpen={showLoading}
        message={'Please wait...'}
      />
      <IonToast
        isOpen={Toast}
        message="更新成功"
        color="success"
        position="top"
        duration={1500}
        onDidDismiss={()=> setToast(false)}
      />
    </IonList>
  );
};

const Setting: React.FC = () => {
  const [alert, setAlert] = useState({
    isOpen: false,
    // header: '通知',
    message: "預設訊息",
  });

  const [aboutModal, setAboutModal] = useState(false)
  const [accountModal, setAccountModal] = useState(false)
  const [reportModal, setReportModal] = useState(false)

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Setting</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Setting</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonList>
          <IonListHeader></IonListHeader>
          <IonItem button onClick={() => setAccountModal(true)}>
            <IonLabel>帳號</IonLabel>
          </IonItem>
          <IonItem button onClick={() => setReportModal(true)}>
            <IonLabel>回報問題</IonLabel>
          </IonItem>
          <IonItem button onClick={() => setAboutModal(true)}>
            <IonLabel>關於打卡系統</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
      <IonModal isOpen={reportModal}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>回報問題</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setReportModal(false)}>關閉</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <ReportForm setReportModal={setReportModal} setAlert={setAlert}/>
        </IonContent>
      </IonModal>
      <IonModal isOpen={accountModal}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>帳號</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setAccountModal(false)}>關閉</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding-horizontal">
          <AccountForm />
        </IonContent>
      </IonModal>
      <IonModal isOpen={aboutModal}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>關於打卡系統</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setAboutModal(false)}>關閉</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor aperiam dignissimos eos cum delectus placeat exercitationem quibusdam, unde porro, perspiciatis impedit distinctio laborum facere? Sequi atque amet laboriosam repellendus ducimus?
          </p>
        </IonContent>
      </IonModal>
      <IonAlert
        isOpen={alert.isOpen}
        header={"通知"}
        message={alert.message}
        buttons={["關閉"]}
        onWillDismiss={() => {
          alert.isOpen = false;
        }}
      />
    </IonPage>
  );
};

export default Setting;
